<template>
  <div>
    <div v-if="loading" class="text-xs-center mt-9" style="margin-top: 40px">
      <v-progress-circular indeterminate color="primary" size="40"></v-progress-circular>
    </div>
    <div v-else>
      <v-layout row wrap>
        <v-flex
          v-ripple
          class="text-xs-center pt-2"
          :style="tab == 'รอการชำระเงิน' ? 'border-bottom: 4px solid #faaa72;' : ''"
          @click="tab = 'รอการชำระเงิน'"
          xs4
        >
          <div>ที่ต้องชำระ</div>
          <div>
            <vue-simple-svg
              :filepath="'/static/img/assets/toa/wallet-outline.svg'"
              width="30px"
              height="auto"
              class="icon"
            />
          </div>
        </v-flex>
        <v-flex
          v-ripple
          class="text-xs-center pt-2"
          :style="tab == 'รอการจัดส่ง' ? 'border-bottom: 4px solid #faaa72;' : ''"
          @click="tab = 'รอการจัดส่ง'"
          xs4
        >
          <div>ที่ต้องจัดส่ง</div>
          <div>
            <vue-simple-svg
              :filepath="'/static/img/assets/toa/truck-delivery-outline.svg'"
              width="30px"
              height="auto"
              class="icon"
            />
          </div>
        </v-flex>
        <v-flex
          v-ripple
          class="text-xs-center pt-2"
          :style="tab == 'จัดส่งสินค้า' ? 'border-bottom: 4px solid #faaa72;' : ''"
          @click="tab = 'จัดส่งสินค้า'"
          xs4
        >
          <div>ที่ต้องได้รับ</div>
          <div>
            <vue-simple-svg
              :filepath="'/static/img/assets/toa/package-variant-closed.svg'"
              width="30px"
              height="auto"
              class="icon"
            />
          </div>
        </v-flex>
      </v-layout>
      <div>
        <div :key="tab">
          <OrderList :title="tab" :user="data" :orders="orderlist(tab)"></OrderList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import OrderList from './ToaOrderList.vue'
export default {
  props: ['value'],
  data() {
    return {
      tab: 'รอการชำระเงิน',
      loading: true,
      data: {
        orderlist: [],
      },
    }
  },
  components: {
    OrderList,
  },
  computed: {
    ...mapGetters(['selectedBot']),
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    orderlist(val) {
      if (val) {
        return this.data.orderlist.filter((el) => el.status == val)
      } else return []
    },
    getInfo() {
      var vm = this
      this.loading = true
      var data = {
        userid: this.value,
        pageid: this.selectedBot.pageid,
      }
      api.toarcustomerpersonalinfo(data, (err, response) => {
        if (response.responsecode == 200 && response.data) {
          vm.data = response.data[0]
        }
        this.loading = false
      })
    },
  },
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/livechat/ToaPaintCustomer.vue